import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Hoje',
    asap: 'ASAP',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Número de quarto',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Número de mesa',
  },
};
